import { render, staticRenderFns } from "./ReportRequirement.vue?vue&type=template&id=3226dc8d&scoped=true"
import script from "./ReportRequirement.vue?vue&type=script&lang=js"
export * from "./ReportRequirement.vue?vue&type=script&lang=js"
import style0 from "./ReportRequirement.vue?vue&type=style&index=0&id=3226dc8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3226dc8d",
  null
  
)

export default component.exports